import React, { FunctionComponent } from 'react';

import { ConfirmDialog } from './ConfirmDialog';

type Props = { onClose: (confirmed: boolean) => void };

export const ConfirmCancel: FunctionComponent<Props> = ({ onClose }) => (
  <ConfirmDialog
    open
    title="Confirm Cancel"
    message="Are you sure you want to cancel? You will lose any unsaved changes."
    onClose={onClose}
    cancelText="No, go back"
  />
);
